module.exports = {"id":"152814","name":"Bobô","rating":"75","photo":"./data/images/photos/2/152814.png","club":{"name":"Sydney FC","logo":"./data/images/clubs/SydneyFC.png"},"positions":["BU"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Bobo0.json
// module id = 613
// module chunks = 0